import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-tall"><path d="M15.25 6.75V2.75H4.75V17.25H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 6.75H8.75V21.25H19.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlidesTall;
